import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import SearchResults from "@/pages/SearchResults";
import ParkingDetail from "@/pages/ParkingDetail";
import Checkout from "@/pages/Checkout";
import BookingConfirmation from "@/pages/BookingConfirmation";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import HostDashboard from "@/pages/HostDashboard";
import HostListingWizard from "@/pages/HostListingWizard";
import HostEarnings from "@/pages/HostEarnings";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminListings from "@/pages/AdminListings";
import AdminHosts from "@/pages/AdminHosts";
import MyBookings from "@/pages/MyBookings";
import Legal from "@/pages/Legal";
import AirportLanding from "@/pages/AirportLanding";
import AirportIndex from "@/pages/AirportIndex";
import { Toaster } from "sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/parking/:offerId" element={<ParkingDetail />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/booking/:reference" element={<BookingConfirmation />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/airport-parking" element={<AirportIndex />} />
              <Route path="/airport-parking/:slug" element={<AirportLanding />} />
              <Route path="/account/bookings" element={<ProtectedRoute><MyBookings /></ProtectedRoute>} />
              <Route path="/host" element={<ProtectedRoute roles={["host", "admin"]}><HostDashboard /></ProtectedRoute>} />
              <Route path="/host/list-space" element={<ProtectedRoute roles={["host", "admin"]}><HostListingWizard /></ProtectedRoute>} />
              <Route path="/host/earnings" element={<ProtectedRoute roles={["host"]}><HostEarnings /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/community-listings" element={<ProtectedRoute roles={["admin"]}><AdminListings /></ProtectedRoute>} />
              <Route path="/admin/hosts" element={<ProtectedRoute roles={["admin"]}><AdminHosts /></ProtectedRoute>} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
